import Button from "@/components/atoms/button";
import InputPhone from "./InputPhone";
import CountryCombobox from "@/components/CountryCombobox";
import { observer } from "mobx-react";
import clsx from "clsx";
import useJoinSmsCheck from "../useJoinUserInfo";
import InputNickname from "./InputNickname";

interface IProps {
    onClick: () => void;
}

const JoinUserInfoView = observer(({onClick}: IProps): JSX.Element => {
    const {phone, phoneNumGuideMsg, isCompleteBtnDisabled, nickname, countryNumber,nicknameGuideMsg, onChangePhoneNumber, onClickRequestBtn, onChangeNickname, onClickNicknameCheckBtn, onClickCompleteBtn, onKeyDownNickname} = useJoinSmsCheck(onClick);

    return (
        <div className="wrap wrap_temporary logn">
        <div className="container">
            <div className="inner-set-pnum">
                <h3 className="form-title body-l-n fw-b w">휴대폰 번호를 입력해주세요.</h3>
                <div className="form-group-join-sms-2">
                    <label className="body-n-n w mar-b">국가 번호를 선택해주세요.</label>
                    <CountryCombobox />
                </div>
                <InputPhone 
                    phoneNumber={phone} 
                    phoneNumGuideMsg={phoneNumGuideMsg} 
                    countryNumber={countryNumber} 
                    onChangePhoneNumber={onChangePhoneNumber} 
                    onClickRequestBtn={onClickRequestBtn}
                />
                <InputNickname 
                    nickname={nickname} 
                    nicknameGuideMsg={nicknameGuideMsg}
                    onChangeNickname={onChangeNickname} 
                    onClickNicknameCheckBtn={onClickNicknameCheckBtn}
                    onKeyDownNickname={onKeyDownNickname}
                />
                <div className="button-area margin-top">
                <Button caption="완료" className={clsx('glass-button body-n-n fw-b but-mar-top', {enabled: !isCompleteBtnDisabled, default_cursor: isCompleteBtnDisabled})} disabled={isCompleteBtnDisabled} onClick={onClickCompleteBtn} />
                </div>
            </div>
            </div>
        </div>
    )
}
)

export default JoinUserInfoView;